<template>
    <select
        class="custom-select select-multiple"
        autocomplete="off"
        :multiple="true"

    >
        <option
            v-for="option in options"
            :value="option"
            :key="option"
        >
            {{ option }}
        </option>

    </select>
</template>

<script>
export default {
    props: {
        selected_options: {
            type: Array,
            default: () => []
        },
        non_deletable_options: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            default: []
        },
        message_on_delete: {
            type: String,
            default: () => ''
        },
        limit: {
            type: Number,
            default: () => 3
        }
    },
    data() {
        return {
            value: this.selected_options
        }
    },
    mounted: function() {
        let _this = this;
        let disabled = false;

        setTimeout(() => {
            $(this.$el).select2({
                allowClear: true,
                maximumSelectionLength: 0,
                closeOnSelect: false,
            }).on('change', function() {
                _this.$emit('input', $(_this.$el).val())
            }).on('select2:unselecting', function(event) {
                const data = event.params.args.data;
                if (_this.non_deletable_options.includes(data.id)) {
                    disabled = true;
                    event.preventDefault();
                    _this.$showErrorMessage(_this.message_on_delete);
                }
            }).on('select2:open', function(event) {
                if (disabled) {
                    $(_this.$el).select2("close");
                    event.preventDefault();
                    disabled = false;
                }
            });

            $(this.$el).select2().val(this.selected_options).trigger('change')

            $('b[role="presentation"]').hide();
            // $('.select2-selection__arrow').append('<img class="arrow" src="/uploads/img/svg/arrow-down.svg">');
        }, 500)

    }
}
</script>
